import { HELP_BASE_PATH } from '@/modules/zendesk/constants.ts';
import { getHelpUrl } from '@/modules/zendesk/helpers.ts';

// To add a new article, please make sure you add a redirect mapping to
// src/modules/zendesk/redirects.ts
// The string used in getHelpUrl can be whatever you like,
// it's used as the source in the redirect.
// e.g. /help/my-article will redirect to depophelp.zendesk.com/hc/en-gb/123234234

export const HELP_ARTICLES = {
  HELP_HOME: HELP_BASE_PATH,
  TERMS_OF_SERVICE: getHelpUrl('terms-of-service'),
  PRIVACY_POLICY: getHelpUrl('privacy-policy'),
  AGE_REQUIREMENT: getHelpUrl('age-guide-to-use-depop'),
  BOOSTED_LISTINGS: {
    INFO: getHelpUrl('boosted-listings'),
    TERMS_AND_CONDITIONS: getHelpUrl('boosted-listings-policy'),
  },
  BULK_LISTING: getHelpUrl('listing-multiple-items'),
  BUYER_PROTECTION: getHelpUrl('buyer-protection'),
  COOKIES_AND_SIMILAR_TECHNOLOGIES_POLICY: getHelpUrl('cookies'),
  HOW_TO_USE_SALES_DOWNLOAD: getHelpUrl('sales-download'),
  REPOP: getHelpUrl('repop'),
  SALES_TAX_FIND_OUT_MORE: getHelpUrl('sales-tax'),
  SHOP_STATS: getHelpUrl('shop-stats'),
  TWO_FACTOR_AUTH_FAQS: getHelpUrl('2fa'),
  CONTACT_US: getHelpUrl('contact-us'),
  TAX: {
    TAX_US_MFT: getHelpUrl('us-sales-tax-faq'),
  },
  SHIPPING: {
    UK: getHelpUrl('shipping-uk'),
    US: getHelpUrl('shipping-us'),
    AU: getHelpUrl('shipping-au'),
  },
  SEND_OFFER: getHelpUrl('send-offer'),
  CONTENT_POLICIES: getHelpUrl('360001792167'),
  BUYING_CATEGORY: getHelpUrl('buying'),
  SELLER_FEES: getHelpUrl('seller-fees-and-charges'),
  SKU: getHelpUrl('how-to-use-sku'),
  CYBER_MONDAY_FREE_SHIPPING: getHelpUrl(
    'Depop-Cyber-Monday-Free-Shipping-in-US-1-December-Terms-and-Conditions'
  ),
  HOW_TO_SHIP: {
    US: getHelpUrl('how-to-ship-us'),
    UK: getHelpUrl('how-to-ship-uk'),
    AUS: getHelpUrl('how-to-ship-australia'),
    BUNDLES: getHelpUrl('how-to-ship-bundles'),
  },
  TARIFFS: getHelpUrl('tariffs-on-parcels-into-the-us'),
  ECO_FRIENDLY_PACKAGING: getHelpUrl('eco-friendly-packaging'),
  DEPOP_PROTECTION_FOR_SELLERS: getHelpUrl('depop-protection-for-sellers'),
  FREE_SHIPPING_CAMPAIGN: getHelpUrl('free-shipping-campaign-article'),
};
